import React, { useEffect } from "react";

import ParseContent from "@molecules/ParseContent";

import { NOTIFICATIONS } from "@const/notifications";

import useStoreInfo from "@queries/useStoreInfo";

import { useLayoutStore } from "@store/layout";

export default function PrivacyPolicy() {
  const { openToast } = useLayoutStore();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const { fetchShopData, shopData: data } = useStoreInfo();

  useEffect(() => {
    void fetchShopData();
  }, []);

  return (
    <section className="pc:gap-10 col-span-8 flex h-fit w-full flex-col gap-5 wrap-break-word">
      <h2 className="text-title pc:flex hidden">Privacy Policy</h2>
      <ParseContent html={data?.shop.privacyPolicy?.body || ""} />
    </section>
  );
}
